import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../../Components/consts'

export const StyledCard = styled('div')(({ theme }) => ({
  overflow: 'visible',
}))

export const HeaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
})

export const TitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.spacing(1),
}))

export const PerGameToggleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  paddingTop: 4,
})

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: 12,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gap: 0,
  },
}))

export const StatSelectionPanel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.offWhite,
  padding: 16,
  borderRadius: 8,
  margin: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: 8,
    margin: theme.spacing(1),
  },
}))

export const ChartContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: 350,
  gridColumn: 'span 3',
  [theme.breakpoints.down('md')]: {
    gridColumn: 'span 1',
    minHeight: 300,
  },
}))
export const StatCheckboxCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}))

export const StatCheckboxLabel = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: fontSizes.small,
  fontWeight: 500,
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.xSmall,
  },
}))

export const ColorIndicator = styled('div')(({ theme }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  [theme.breakpoints.down('sm')]: {
    width: 8,
    height: 8,
  },
}))

export const TooltipPaper = styled('div')(({ theme }) => ({
  padding: 10,
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  zIndex: 5,
  minWidth: 120,
  border: `1px solid ${colors.gray.gray20}`,
  borderRadius: 8,
}))

export const CareerTooltipContainer = styled('div')<{ entryColor?: string }>(
  ({ entryColor }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    '& .inner': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 1,
      '& .indicator': {
        width: 10,
        height: 10,
        backgroundColor: entryColor ?? colors.gray.gray40,
        borderRadius: '50%',
        marginRight: 4,
      },
    },
  })
)
